import Vue from 'vue'
import api from '@/fetch/api'

var picUrl = process.env.PIC_URL

export function formatTime(time){
  var date = new Date(time)
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hour = date.getHours()
  const minute = date.getMinutes()
  const second = date.getSeconds()

  return [year, month, day].map(formatNumber).join('/') + ' ' + [hour, minute, second].map(formatNumber).join(':')
}

export function formatNumber(n){
  n = n.toString()
  return n[1] ? n : '0' + n
}
export function formatTimeTwo(number,format){

  var formateArr = ['Y', 'M', 'D', 'h', 'm', 's'];
  var returnArr = [];

  var date = new Date(number);
  returnArr.push(date.getFullYear());
  returnArr.push(formatNumber(date.getMonth() + 1));
  returnArr.push(formatNumber(date.getDate()));

  returnArr.push(formatNumber(date.getHours()));
  returnArr.push(formatNumber(date.getMinutes()));
  returnArr.push(formatNumber(date.getSeconds()));

  for (var i in returnArr) {
    format = format.replace(formateArr[i], returnArr[i]);
  }
  return format;
}
//import Message  from './message.js'
// 浮点数运算
export function add(a, b) { //加
	var c, d, e;
	try {
		c = a.toString().split(".")[1].length;
	} catch(f) {
		c = 0;
	}
	try {
		d = b.toString().split(".")[1].length;
	} catch(f) {
		d = 0;
	}
	return e = Math.pow(10, Math.max(c, d)), (mul(a, e) + mul(b, e)) / e;
}

export function sub(a, b) { //减
	var c, d, e;
	try {
		c = a.toString().split(".")[1].length;
	} catch(f) {
		c = 0;
	}
	try {
		d = b.toString().split(".")[1].length;
	} catch(f) {
		d = 0;
	}
	return e = Math.pow(10, Math.max(c, d)), (mul(a, e) - mul(b, e)) / e;
}

export function mul(a, b) { //乘
	var c = 0,
		d = a.toString(),
		e = b.toString();
	try {
		c += d.split(".")[1].length;
	} catch(f) {}
	try {
		c += e.split(".")[1].length;
	} catch(f) {}
	return Number(d.replace(".", "")) * Number(e.replace(".", "")) / Math.pow(10, c);
}

export function div(a, b) { //除
	var c, d, e = 0,
		f = 0;
	try {
		e = a.toString().split(".")[1].length;
	} catch(g) {}
	try {
		f = b.toString().split(".")[1].length;
	} catch(g) {}
	return c = Number(a.toString().replace(".", "")), d = Number(b.toString().replace(".", "")), mul(c / d, Math.pow(10, f - e));
}
// 浮点数运算 End
export default {
	install(Vue, options) {
		Vue.prototype.imgpath = function() {

          // return location.protocol+'//'+'pic.dzq.com/';

          return location.protocol+'//'+ picUrl;

			},
			Vue.prototype.myhost = function() {

          // return location.protocol+'//'+'pic.dzq.com/';

          return location.protocol+'//'+ picUrl;

      },
      Vue.prototype.qcodeurl = function() {
				// return location.protocol+'//'+'pic.dzq.com/';
				  return location.protocol+'//'+ location.host;

			},
			Vue.prototype.gotoqcode = function(data) {
				// return 'http://pic.dzq.com/';
				location.href = '/qcode/' + data;
			},
			//四舍五入
			Vue.prototype.round = function(a) {

				return Math.round(a * 100) / 100;
			},
			//会员卡折扣
			Vue.prototype.cost = function(a) {
				if(a==undefined){
					return;
				}
				let mcost=a.split('-');
				if(mcost.length>1){
					return Math.round(mcost[0]*10*100)/100+'-'+ Math.round(mcost[1]*10*100)/100;
				}
				else{
					return Math.round(a*10*100)/100;
				}
			},
			Vue.prototype.add = function(a, b) {
				return add(a, b);
			},
			Vue.prototype.sub = function(a, b) {
				return sub(a, b);
			},
			Vue.prototype.mul = function(a, b) {
				return mul(a, b);
			},
			Vue.prototype.div = function(a, b) {
				return div(a, b);
			},
			Vue.prototype.islogin = function() {
				var data = localStorage.getItem('authtoken');
				var token = '';
				if(data != undefined || data != null) {
					var dataObj = JSON.parse(data);
					if(new Date().getTime() - dataObj.time > (1000 * 60 * 60 * 24 * 7)) {
						localStorage.clear();
						return false
					} else {
						return true;
					}
				} else {
					return false;
				}
      },
      //判断获取数据的空类型
			Vue.prototype.getdatanull = function(item) {
				if(item == null){
					return false;
				}
				if(item == "null"){
					return false;
        }
        if(item == ''){
					return false;
				}
				if(item.length == 0){
					return false;
				}
				if(item == undefined){
					return false;
				}
				if(item == "undefined"){
					return false;
				}
				else{
					return item;
				}
			},
      	// 3. 注入组件
			Vue.mixin({
				data(){
					return{
            takeoutsData:'', //外卖设置
            senddata: false,//是否打烊
            versionStatus: false, //版本状态
            shopStyleData:'',   //店铺装饰信息
            wxdata: {   //唤醒微信支付数据
              debug: false,
              appId: '',
              timeStamp: '',
              nonceStr: '',
              package: '',
              signType: '',
              paySign: ''
            },
            mchNo:''  //订单号
					}
				},
				methods: {
          senddatabox() {  //交易设置接口
            // beginOrderMoney     起送费
            // canPayOnDelivery    货到付款
            // freeLimit           满免配送费金额
            // merSend             商家配送
            // payChannelEnable    支付通道
            // selfGet             到店自提
            // sendFee             配送金额
            // sendRange           配送范围
            // serviceOpen         外卖服务是否开启
            // enableStockLimit     库存校验
            let data = {
              shopAlias:this.$route.query.shopAlias
            }
            api.takeoutset(this.geturl(data)).then(res => {
              this.takeoutsData = res.resultObj
              if(res.resultObj.serviceOpen==false){
                this.senddata = true;
                return;
              }
              if(res.resultObj.payChannelEnable==false){
                this.senddata = true;
                return;
              }
            })
          },
          shopMenueResource(){   //获取店铺服务套餐的权限信息
            let data = {
              loginShopAlias:this.$route.query.shopAlias
            }
            api.getShopMenueResource(this.geturl(data)).then(res => {
              if(res.resultObj.versionStatus == 'normal') {
                this.versionStatus = true
              }
            })
          },
          getShopStyleData(){ //店铺-获取店铺装饰模板信息接口
            let data = {
              loginShopAlias:this.$route.query.shopAlias
            }
            api.getshopStyleData(this.geturl(data)).then(res => {
              this.shopStyleData = res.resultObj
            })
          },
          discountHadPay(){
            var _this = this;
            let data = {
              orderNumber:_this.mchNo
            }
            api.discountTradeHadPay(_this.geturl(data)).then(res => {
              _this.$router.replace({
                path: '/shopcard/info',
                query: {
                  "shopAlias": _this.$route.query.shopAlias,
                  "cardNo": _this.$route.query.cardNo,
                  "type": _this.$route.query.type,
                }
              })
            }, res => {
              if (res.resultCode == 28012){ //订单状态未知的时候  重新请求
                setTimeout(function(){
                  _this.discountHadPay();
                },1000)
              }else{
                _this.$toast(res.resultMsg);
              }
            })
          },
          countHadPay(){
            var _this = this;
            let data = {
              orderNumber:_this.mchNo
            }
            api.countTradeHadPay(_this.geturl(data)).then(res => {
              _this.$router.replace({
                path: '/shopcard/info',
                query: {
                  "shopAlias": _this.$route.query.shopAlias,
                  "cardNo": _this.$route.query.cardNo,
                  "type": _this.$route.query.type,
                }
              })
            }, res => {
              if (res.resultCode == 28012){ //订单状态未知的时候  重新请求
                setTimeout(function(){
                  _this.countHadPay();
                },1000)

              }else{
                _this.$toast(res.resultMsg);
              }
            })
          },
          goOrderPay(payType,res){
            var retCode = res.resultObj.retCode;
            this.mchNo = res.resultObj.mchNo;
            if(payType == 'weixin') {
              //this.wxdata.appId = this.item.wechat_app_id;
              this.wxdata.appId = res.resultObj.wxAppId;
              this.wxdata.timeStamp = res.resultObj.wxTimeStamp;
              this.wxdata.nonceStr = res.resultObj.wxNonceStr;
              this.wxdata.package = res.resultObj.wxPackage;
              this.wxdata.signType = res.resultObj.wxSignType;
              this.wxdata.paySign = res.resultObj.wxPaySign;
              //商户订单号
              if(typeof WeixinJSBridge == "undefined") {
                if(document.addEventListener) {
                  document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false);
                } else if(document.attachEvent) {
                  document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady);
                  document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady);
                }
              } else {
                this.onBridgeReady();
              }

            }
            if(payType == 'alipay') {
              var _this = this;
              var tradeNo = res.resultObj.outOrderNo;
              if(tradeNo.indexOf('frag') >= 0) {
                tradeNo = tradeNo.split('frag')[0];
              }

              if(retCode == "86") {
                _this.$toast("亲！在街上店铺使用支付宝钱包付款时，必须使用支付宝账号登录才可以实现支付。");
                //updateIncomeDetailRemark(incomeDetailId,"亲！在街上店铺使用微信付款时，必须使用微信账号登录才可以实现支付,code=86");
                return;
              } else if(retCode == "87" || retCode == "95") {
                _this.$toast("下单失败。");
                return;
              } else if(retCode == "88") {
                _this.$toast("订单金额已超过每日限额，无法完成支付。");
                //updateIncomeDetailRemark(incomeDetailId,"订单金额已超过每日限额，无法完成支付,code=88");
                return;
              } else if(retCode == "89") {
                _this.$toast("二维码不存在。");
                //updateIncomeDetailRemark(incomeDetailId,"二维码不存在。code=89");
                return;
              } else if(retCode == 1) {

                AlipayJSBridge.call("tradePay", {
                  tradeNO: tradeNo

                }, function(result) {

                  var resultCode = result.resultCode;
                  //6001 取消操作，9000 支付成功
                  if(resultCode == "9000") {
                    if(_this.$route.params.id == 'cardbuy'){  //折扣卡 计次卡 购买
                      if(_this.$route.query.type == 'count'){
                        _this.countHadPay()
                      }else{
                        _this.discountHadPay();
                      }
                      //修改为已支付但未到账

                    }else if(_this.$route.params.id == 'cellorder'){  //线上下单
                      //修改为已支付但未到账
                      setTimeout(function(){
                        _this.$router.replace({
                          path: '/cell/orderdetail',
                          query: {
                            "shopAlias": _this.$route.query.shopAlias,
                            "orderno": _this.$route.query.goodsOrderNo,
                            "success":1
                          }
                        })
                      },1500)
                    }else if(_this.$route.params.id == 'storepay'){ //储值卡充值
                      if(_this.$route.query.qrcodeid != undefined){
                        location.href = location.protocol+'//'+ location.host +'/qcode/'+_this.$route.query.qrcodeid + '?shopAlias=' + _this.$route.query.shopAlias + '&casher=' + _this.$route.query.casher;
                      }else{
                        setTimeout(function(){
                          _this.$router.replace({
                            path: '/shopcard/success',
                            query: {
                              "shopAlias": _this.$route.query.shopAlias
                            }
                          })
                        },1500)
                      }
                    }

                    //window.location.href=baseUrl+'/msbankali/hadPay?mchNo='+mchNo;
                  } else if(resultCode == "6001") {
                    //取消、支付失败操作
      //										_this.$router.push({
      //											path: '/cell/payfail',
      //											query: {
      //												shopAlias: _this.$route.query.shopAlias,
      //												"orderno": _this.$route.query.goodsOrderNo
      //											}
      //										})

                    //window.location.href=baseUrl+'/msbankali/hadPayFail?alias='+alias;
                    // updateIncomeDetailRemark(incomeDetailId,"6001:用户中途取消。");
                  } else {
                    _this.$router.replace({
                      path: '/cell/payfail',
                      query: {
                        shopAlias: _this.$route.query.shopAlias,
                        // "orderno": _this.$route.query.goodsOrderNo
                      }
                    })
                    // updateIncomeDetailRemark(incomeDetailId,"支付宝支付失败："+resultCode);
                    //支付失败

                  }
                });
              }
            }
          },
          //调用微信支付界面
          onBridgeReady() {
            var _this = this;
            WeixinJSBridge.invoke(
              'getBrandWCPayRequest', _this.wxdata,
              function(res) {
                _this.wxmsg = res;
                // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
                if(res.err_msg == "get_brand_wcpay_request:ok") {
                  //修改为已支付但未到账
                    if(_this.$route.params.id == 'cardbuy'){  //折扣卡 计次卡 购买
                      //修改为已支付但未到账
                      if(_this.$route.query.type == 'count'){

                        _this.countHadPay()

                      }else{

                        _this.discountHadPay();

                      }
                    }else if(_this.$route.params.id == 'cellorder'){  //线上下单
                      //修改为已支付但未到账
                      setTimeout(function(){
                        _this.$router.replace({
                          path: '/cell/orderdetail',
                          query: {
                            "shopAlias": _this.$route.query.shopAlias,
                            "orderno": _this.$route.query.goodsOrderNo,
                            "success":1
                          }
                        })
                      },1500)
                    }else if(_this.$route.params.id == 'storepay'){ //储值卡充值
                      if(_this.$route.query.qrcodeid != undefined){
                        location.href = location.protocol+'//'+ location.host +'/qcode/'+_this.$route.query.qrcodeid + '?shopAlias=' + _this.$route.query.shopAlias + '&casher=' + _this.$route.query.casher;
                      }else{
                        setTimeout(function(){
                          _this.$router.replace({
                            path: '/shopcard/success',
                            query: {
                              "shopAlias": _this.$route.query.shopAlias
                            }
                          })
                        },1500)
                      }


                    }

                  //window.location.href = baseUrl + '/msweixin/hadPay?mchNo=' + mchNo;
                } else if(res.err_msg == "get_brand_wcpay_request:fail") {
                  _this.$toast(res.err_code + ":" + res.err_desc + ":" + res.err_msg);
                  //3:不允许跨号支付（gh_4bfb97195d7d--wx9f5e95f9a8da6dd9）:get_brand_wcpay_request:fail
                  // api.updateIncome(tempIncomeDetailId, "微信支付错误：get_brand_wcpay_request:fail，code=" + res.err_code);
                  if(res.err_code == 3) {
                    _this.$toast("不允许跨行支付");
                    return;
                  }
                  _this.$router.replace({
                    path: '/cell/payfail'
                  })

                } else if(res.err_msg == "get_brand_wcpay_request:cancel") {
                  //取消支付
                  // api.updateIncome(tempIncomeDetailId, "微信支付取消：get_brand_wcpay_request:cancel，code=" + res.err_code);
                  return;
                  //取消
                } else if(res.err_msg == "get_brand_wcpay_request:fail_invalid appid") {
                  _this.$toast("程序内部错误。");
                  // api.updateIncome(tempIncomeDetailId, "微信支付程序内部错误：get_brand_wcpay_request:fail_invalid appid，code=" + res.err_code);
                  return;
                } else {
                  // api.updateIncome(tempIncomeDetailId, "微信支付未知错误：err_msg=" + res.err_msg + "，code=" + res.err_code);
                  return;
                }
              }
            );
          },
				},
				created() {

				},
			})
      Vue.prototype.merPush = function() { //存储收银员员信息
				if (this.$route.query.casher != undefined && this.$route.query.shopAlias != undefined) {
          localStorage['mre_'+ this.$route.query.shopAlias] = this.$route.query.casher
          // localStorage['mre_'+ this.$route.query.shopAlias+'_'+this.$route.query.casherAlias] = this.$route.query.casherAlias
        }
      },
      Vue.prototype.geturl = function(item) {
				let urldata='';
				for(var key in item){
				 	urldata += key +'=' + item[key] +'&';
				}
				return urldata.substring(0,urldata.length-1);
      },
			Vue.prototype.locget = function(item) {
				if(!localStorage.getItem(item)){
					return false;
				}
				return JSON.parse(localStorage.getItem(item));
			},
			Vue.prototype.authhost = function(a, b) {
				var s = location.protocol+'//' + location.host;
				return s;
			}
			Vue.prototype.link = function(a, b) {
				var s = location.protocol+'//' + location.host;
				return s;
			}
		    Vue.prototype.share = function(title,desc,link,imgUrl) {
      var s = location.href;
		    api.wxshare({urlPath:s})
			    .then(res => {
        var data = res.resultObj;
        // alert(JSON.stringify(data))
        // alert("标题"+title)
        // alert("描述"+desc)
        // alert("分享链接"+link)
        // alert("分享图标"+imgUrl)
				wx.config({
					appId: data.appId, // 必填，公众号的唯一标识   由接口返回
					timestamp: data.timestamp, // 必填，生成签名的时间戳 由接口返回
					nonceStr: data.noncestr, // 必填，生成签名的随机串 由接口返回
					signature: data.signature, // 必填，签名 由接口返回
					jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'] // 此处填你所用到的方法
				});
				wx.ready(() => {
					wx.updateAppMessageShareData({ // 分享给朋友
						title: title, // 分享标题
						desc: desc, // 分享描述
						link: link, // 分享链接 默认以当前链接
            imgUrl: imgUrl, // 分享图标
            success: function () {
              // alert("设置成功")
              // return true
            }
					})
        })
        wx.ready(function () {      //需在用户可能点击分享按钮前就先调用
          wx.updateTimelineShareData({
              title: title, // 分享标题
              link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: imgUrl, // 分享图标
              success: function () {
                // 设置成功
                // alert("设置成功")
                // return true
              }
          })
        });


			})
		    }
	}
}

// Vue.directive('title', {
// 	inserted: function(el, binding) {
//     console.log("binding")
// 		console.log(binding)
// 		document.title = el.innerText
// 		el.remove();
// 	}
// })



// WEBPACK FOOTER //
// ./src/plugins/plugins.js